import Arrow from "@assets/icons/arrow-right.svg";
import { Block } from "@components/block";
import { Button } from "@components/button";
import { StatusBlock, StatusBlockType } from "@components/status-block";
import { Config, DoubleText, Table } from "@components/table";
import { useAppeals } from "@features/appeals";
import { formatDate, formatTime } from "@helpers/date";
import { useNavigateWithUserId } from "@hooks/use-navigate";
import { useEffect, useState } from "react";
import styles from "./disputes.module.scss";
import { formatRubles, formatUsdt } from "@helpers/format";
import { MergedAppeal } from "@features/appeals/slice";
import { EllipsisText } from "@components/ellipsis-text";
import { MerchantAppealModal } from "../../../../../pages/merchant/disputes/merchantAppealModal";
import { useBoolState } from "@hooks/use-bool-state";
import { useWebSocket } from "@request/useWebsocket";
import { WebsocketUpdateType } from "@request/websocket";

export const merchantAppealConfig: Config<MergedAppeal> = [
  {
    label: "Номер заявки",
    source: "order_invid",
    renderComponent: (data) => (
      <EllipsisText text={data} startLength={10} copy />
    ),
  },
  {
    label: "Дата и время спора",
    source: "created_at",
    renderComponent: (dateTime) => {
      const time = formatTime(new Date(dateTime));
      const date = formatDate(new Date(dateTime));
      return <DoubleText text={time} subText={date} />;
    },
  },
  {
    label: "Сумма заявки",
    source: "order_start_amount",
    renderComponent: (cell, item) => {
      if (cell == null || item.order_start_amount_usdt == null) return "";
      const rub = formatRubles(cell);
      const usdt = formatUsdt(item.order_start_amount_usdt);
      return <DoubleText text={rub} subText={usdt} />;
    },
  },
  {
    label: "Измененная сумма",
    source: "merchant_amount",
    renderComponent: (cell, item) => {
      if (cell == null || item.merchant_amount_usdt == null) return "";
      const rub = formatRubles(cell);
      const usdt = formatUsdt(item.merchant_amount_usdt);
      return <DoubleText text={rub} subText={usdt} />;
    },
  },
  {
    label: "Итоговая сумма",
    source: "order_final_amount",
    renderComponent: (cell, item) => {
      if (cell == null || item.order_final_amount_usdt == null) return "";
      const rub = formatRubles(cell);
      const usdt = formatUsdt(item.order_final_amount_usdt);
      return <DoubleText text={rub} subText={usdt} />;
    },
  },
  {
    label: "Касса",
    source: "cash_register",
    renderComponent: (cell) => cell.name
  },
  {
    label: "Тип",
    source: "order_type",
    renderComponent: (order_type) => {
      switch (order_type) {
        case "pay_out":
          return "Вывод";
        case "pay_in":
          return "Сделка";
        default:
          return "Не определено";
      }
    },
  },
  {
    label: "Статус",
    source: "status",
    renderComponent: (status) => {
      let text = "";
      let statusType: StatusBlockType;
      switch (status) {
        case "canceled":
          text = "Отклонен";
          statusType = StatusBlockType.Error;
          break;
        case "approved":
          text = "Пересмотрен";
          statusType = StatusBlockType.Success;
          break;
        case "processing":
        case "pending_support":
        case "created":
        default:
          text = "На рассмотрении";
          statusType = StatusBlockType.Warning;
          break;
      }
      return <StatusBlock text={text} type={statusType} />;
    },
  },
];

export const Disputes = () => {
  const navigate = useNavigateWithUserId();

  const { state, getMerchantAppeals } = useAppeals();
  const [isModalOpen, showModal, hideModal] = useBoolState(false);
  const [data, setData] = useState<MergedAppeal>();
  const { lastMessage } = useWebSocket();

  useEffect(() => {
    if (lastMessage && lastMessage.type == WebsocketUpdateType.Appeal) {
      getMerchantAppeals({ page: 1, limit: 10, status: "processing" });
    }
  }, [lastMessage]);
  useEffect(() => {
    getMerchantAppeals({ page: 1, limit: 10, status: "processing" });
  }, [getMerchantAppeals]);

  const onClick = (data: MergedAppeal) => {
    showModal();
    setData(data);
  };
  return (
    <>
      <Block className={styles.disputes}>
        <div className={styles.header}>
          <h3>Открытые споры</h3>
          <Button
            icon={Arrow}
            onClick={() => {
              navigate("deals/disputes");
            }}
          >
            Посмотреть все
          </Button>
        </div>
        <Table
          // onRowClick={(row) => {
          //   navigate(`/devices/${row.device.id}/request/${row.id}`);
          // }}
          data={state.appeals?.slice(0, 5)}
          loading={state.loading}
          config={merchantAppealConfig}
          onRowClick={onClick}
        />
      </Block>
      {data && (
        <MerchantAppealModal
          isOpen={isModalOpen}
          hide={hideModal}
          data={data}
        />
      )}
    </>
  );
};
